export const RECOMMENDED_ACTIONS_CONTEXT_KEY = 'additionalContext.previous_pills';

export const CONVERSATIONAL_DISCOVERY_COACH_CONFIG = {
  coachModeId: 'CONVERSATIONAL_DISCOVERY',
  coachActionId: 'TYPED_MESSAGE',
};

export const ROUTER_COACH_CONFIG = {
  coachModeId: 'AI_SEARCH_V2',
  coachActionId: 'ROUTER',
};
